// extracted by mini-css-extract-plugin
export default {"blackDate":"register-result_blackDate__-jW52"};